import React, { useState } from 'react';

interface SignupSectionProps {
  onEmailSubmit: (email: string) => void;
}

const SignupSection: React.FC<SignupSectionProps> = ({ onEmailSubmit }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      onEmailSubmit(email);
    }
  };

  return (
    <section className="py-20 px-4 bg-green-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-8 text-green-800">
          5초면 충분합니다
        </h2>
        
        <p className="text-xl text-gray-600 mb-12">
          복잡한 가입 절차 없이 이메일 주소만으로 바로 시작하세요
        </p>
        
        <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
          <div className="flex flex-col sm:flex-row gap-4 mb-6">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="이메일 주소를 입력하세요"
              className="flex-1 px-6 py-4 text-lg rounded-lg border-2 border-green-300 focus:border-green-500 focus:outline-none"
              required
            />
            <button
              type="submit"
              className="bg-green-600 hover:bg-green-700 text-white font-bold px-8 py-4 text-lg rounded-lg transition-colors duration-200 whitespace-nowrap"
            >
              무료 구독하기
            </button>
          </div>
        </form>
        
        <div className="flex justify-center items-center space-x-8 text-green-600 text-sm">
          <div className="flex items-center">
            <span className="w-4 h-4 bg-green-500 rounded-full mr-2"></span>
            <span>즉시 구독 확인</span>
          </div>
          <div className="flex items-center">
            <span className="w-4 h-4 bg-green-500 rounded-full mr-2"></span>
            <span>보너스 가이드 전송</span>
          </div>
          <div className="flex items-center">
            <span className="w-4 h-4 bg-green-500 rounded-full mr-2"></span>
            <span>언제든 구독 해지</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignupSection;
